import { cn } from '@dreamstack/util/src/cn'
import React from 'react'
import { ChildrenBlockSpacingContainer } from '../contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '../contentful/ContentfulBlocks'
import { TwoColumnLayoutContactAndNewsletterCTAs } from './TwoColumnLayoutContactAndNewsletterCTAs'

import { BlockTwoColumn } from '@dreamstack/payload/src/payload-types'

interface TwoColumnContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  mobileColumnOrder: TwoColumnLayoutMobileColumnOrder
}
export const TwoColumnContainer: React.FC<TwoColumnContainerProps> = ({
  mobileColumnOrder,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      'flex space-y-px-48',
      mobileColumnOrder === 'LeftOverRight' ? 'flex-col' : 'flex-col-reverse',
      'md:flex-row md:space-x-px-48 md:space-y-0 lg:space-x-px-64',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

interface StyledColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  alignContentRight?: boolean
  hasOffset?: boolean
  verticalCenter?: boolean
  withOverhang?: boolean
  left: boolean
}
export const StyledColumn: React.FC<StyledColumnProps> = ({
  alignContentRight,
  hasOffset,
  verticalCenter,
  withOverhang,
  left,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      'flex-1 flex flex-col max-w-full overflow-hidden',
      alignContentRight && 'text-right',
      hasOffset && 'md:pt-px-80 lg:pt-px-196',
      verticalCenter && 'justify-center',
      withOverhang && (left ? 'md:-mr-px-196 md:z-10' : 'md:-ml-px-196'),
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

type TwoColumnLayoutVariant = '50/50' | '60/60'
export type TwoColumnLayoutMobileColumnOrder = 'LeftOverRight' | 'RightOverLeft'

interface TwoColumnLayoutProps {
  block: BlockTwoColumn
}

export const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({ block }) => {
  if (!block) return null
  const variant: TwoColumnLayoutVariant = (block.variant as any) || '50/50'
  const mobileColumnOrder: TwoColumnLayoutMobileColumnOrder =
    (block.mobileColumnOrder as any) || 'LeftOverRight'

  const withOverhang = variant === '60/60'

  const appendContactAndNewsletterCtAs = !!block.appendContactAndNewsletterCTAs

  return (
    <TwoColumnContainer mobileColumnOrder={mobileColumnOrder}>
      <StyledColumn
        alignContentRight={block.leftColumnTextRight ?? undefined}
        verticalCenter={block.verticalCenterLeftColumn ?? undefined}
        withOverhang={withOverhang}
        left={true}
      >
        <ChildrenBlockSpacingContainer>
          <ContentfulBlocks
            // blocks={getBlockChildren(block, block.leftColumnCollection?.items)}
            blocks={block.leftColumn ?? []}
          />
        </ChildrenBlockSpacingContainer>
      </StyledColumn>
      <StyledColumn
        verticalCenter={block.verticalCenterRightColumn ?? undefined}
        hasOffset={block.rightColumnOffset ?? undefined}
        withOverhang={withOverhang}
        left={false}
      >
        <ChildrenBlockSpacingContainer>
          <ContentfulBlocks
            // blocks={getBlockChildren(block, block.rightColumnCollection?.items)}
            blocks={block.rightColumn ?? []}
          />
        </ChildrenBlockSpacingContainer>
        {appendContactAndNewsletterCtAs && (
          <TwoColumnLayoutContactAndNewsletterCTAs />
        )}
      </StyledColumn>
    </TwoColumnContainer>
  )
}
